import React from 'react';

import styled from 'styled-components';

import { getOccupancy2TestId } from './testIdUtils';

const Title = styled.div`
  font-family: var(--font-regular);
  font-size: 14px;
`;

const Subtitle = styled.div`
  color: var(--text-secondary);
  font-size: 12px;
`;

type Props = {
  occupancy?: [string, number, number, boolean];
  dataTestId?: string;
};

const CMASummaryTableDataLivingTypeOccupancy = ({ occupancy, dataTestId }: Props) => {
  if (!occupancy?.length) {
    return null;
  }
  const [occupancyPercentage, totalApartmentsUnits, freeApartmentsUnits, hideUnitsRatio] = occupancy;
  const percentage = occupancyPercentage ? `${parseFloat(occupancyPercentage).toFixed(0)}%` : '';
  const showUnitsRatio = !hideUnitsRatio && totalApartmentsUnits > 0 && freeApartmentsUnits != null;

  const freeUnits = showUnitsRatio ? `${totalApartmentsUnits - freeApartmentsUnits}/${totalApartmentsUnits} units` : '';

  return (
    <div data-test-id={dataTestId}>
      <Title>{percentage}</Title>
      {showUnitsRatio && <Subtitle data-test-id={getOccupancy2TestId(dataTestId)}>{freeUnits}</Subtitle>}
    </div>
  );
};

export default CMASummaryTableDataLivingTypeOccupancy;
